function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 0.121,
  x2: 1,
  y2: 0.111,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#013d54"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#019add"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.473,
  y1: 0.172,
  x2: 0.233,
  y2: 0.789,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#d5e000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a0be00",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-Homescreen"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1920,
  height: 1080
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Homescreen",
  clipPath: "url(#clip-Homescreen)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1920,
  height: 1080,
  fill: "#01374f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_35095",
  "data-name": "Pfad 35095",
  d: "M0,0H1920V265L1347.792,66.539,0,265Z",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_35094",
  "data-name": "Pfad 35094",
  d: "M0,0,1346.958-204.178,1920-73.744V7.145L1346.958-173.844,0,99.156Z",
  transform: "translate(0 260)",
  fill: "url(#linear-gradient-2)"
}));

function SvgLoginHomeBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginHomeBg);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTkyMCIgaGVpZ2h0PSIxMDgwIg0KICB2aWV3Qm94PSIwIDAgMTkyMCAxMDgwIj4NCiAgPGRlZnM+DQogICAgPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHkxPSIwLjEyMSIgeDI9IjEiIHkyPSIwLjExMSIgZ3JhZGllbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPg0KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMDEzZDU0IiAvPg0KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDE5YWRkIiAvPg0KICAgIDwvbGluZWFyR3JhZGllbnQ+DQogICAgPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQtMiIgeDE9IjAuNDczIiB5MT0iMC4xNzIiIHgyPSIwLjIzMyIgeTI9IjAuNzg5Ig0KICAgICAgZ3JhZGllbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPg0KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZDVlMDAwIiAvPg0KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjYTBiZTAwIiBzdG9wLW9wYWNpdHk9IjAuOCIgLz4NCiAgICA8L2xpbmVhckdyYWRpZW50Pg0KICAgIDxjbGlwUGF0aCBpZD0iY2xpcC1Ib21lc2NyZWVuIj4NCiAgICAgIDxyZWN0IHdpZHRoPSIxOTIwIiBoZWlnaHQ9IjEwODAiIC8+DQogICAgPC9jbGlwUGF0aD4NCiAgPC9kZWZzPg0KICA8ZyBpZD0iSG9tZXNjcmVlbiIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtSG9tZXNjcmVlbikiPg0KICAgIDxyZWN0IHdpZHRoPSIxOTIwIiBoZWlnaHQ9IjEwODAiIGZpbGw9IiMwMTM3NGYiIC8+DQogICAgPHBhdGggaWQ9IlBmYWRfMzUwOTUiIGRhdGEtbmFtZT0iUGZhZCAzNTA5NSIgZD0iTTAsMEgxOTIwVjI2NUwxMzQ3Ljc5Miw2Ni41MzksMCwyNjVaIg0KICAgICAgZmlsbD0idXJsKCNsaW5lYXItZ3JhZGllbnQpIiAvPg0KICAgIDxwYXRoIGlkPSJQZmFkXzM1MDk0IiBkYXRhLW5hbWU9IlBmYWQgMzUwOTQiIGQ9Ik0wLDAsMTM0Ni45NTgtMjA0LjE3OCwxOTIwLTczLjc0NFY3LjE0NUwxMzQ2Ljk1OC0xNzMuODQ0LDAsOTkuMTU2WiINCiAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMjYwKSIgZmlsbD0idXJsKCNsaW5lYXItZ3JhZGllbnQtMikiIC8+DQogIDwvZz4NCjwvc3ZnPg==";
export { ForwardRef as ReactComponent };